module.exports = __webpack_public_path__ + "img/p1.8a93e082.png";